import styled, { css } from 'styled-components';
import { FlexCenterAligned, FlexColumn } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';
import { Typography } from '../../ui/Typography';

const getGalleryButtonWidth = (isPhoneShown: boolean) => css`
  width: 50px;
  height: 50px;

  @media (min-width: ${Breakpoints.tablet}px) {
    width: ${isPhoneShown ? 'max-content' : '220px'};
  }
  @media (min-width: ${Breakpoints.desktop}px) {
    width: ${isPhoneShown ? 'max-content' : '200px'};
  }
`;

export const PhoneButtonContainer = styled(FlexCenterAligned)<{
  $isPhoneShown: boolean;
  $isGallery: boolean;
}>`
  background-color: ${({ $isPhoneShown, theme }) =>
    $isPhoneShown ? 'transparent' : theme.colors.systemColors.green};
  border-radius: 50%;
  cursor: pointer;

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 14px;
    gap: 10px;
  }

  ${({ $isGallery, $isPhoneShown }) =>
    $isGallery && getGalleryButtonWidth($isPhoneShown)};

  ${({ $isGallery, $isPhoneShown }) =>
    !$isGallery &&
    $isPhoneShown &&
    css`
      justify-content: flex-start;
    `};

  ${({ $isGallery, $isPhoneShown }) =>
    !$isGallery &&
    !$isPhoneShown &&
    css`
      padding: 10px 0;
    `}
`;

export const PhoneButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;

export const PhoneLinksContainer = styled(FlexColumn)`
  gap: 5px;
`;

export const Row = styled(FlexCenterAligned)`
  gap: 5px;
`;

export const Column = styled(FlexColumn)`
  align-items: center;
`;

export const PhoneLink = styled.a<{ $isGallery: boolean }>`
  display: block;
  text-decoration: none;
  font-size: 22px;
  font-weight: bold;

  ${({ $isGallery, theme }) =>
    $isGallery &&
    css`
      color: ${theme.colors.text.white};
    `}
`;

export const MaskedPhoneText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
  margin: 0;
`;
